import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'types';
import { initialState } from '.';

const selectSlice = (state: RootState) => state.dialogAlert || initialState;

export const selectDialogAlert = createSelector([selectSlice], state => state);
